module.exports = __webpack_public_path__ + "static/media/Group 2652.8fc54cb8.svg";